module.exports = __webpack_public_path__ + "5227dcd65cad4411b7030a625aacbebe.jpg";